import { DATATABLES_STATE } from '../../constants';

export const dataTableAction = (dataTableState) => {
    return {
        type: DATATABLES_STATE,
        dataTableState,
    };
};
